import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Heading2 } from '@blueprint/ui';

export const Container = styled('div')(
    ({ theme: { spacing } }) => css`
        padding: ${spacing['16px']};
    `
);

export const Heading = styled(Heading2)(
    ({ theme: { spacing } }) => `
    margin: ${spacing['16px']} 0;

    &:first-of-type {
        margin-top: 0;
    }
`
);
